/**
 * The purpose of this file is to provide formatting information
 * for all of the unit types that display fields can have
 *
 * primitive units are the units of the base value for a display field.
 *
 * format units are the units that the value is formatted to.
 *
 * aggregated units are units that need to be aggregated from the blob before sorting.
 *
 * For example, lets consider the pricePerSf field. The primitive unit is number and the
 * formatUnit is pricePerSquare foot. This way we have a base number value wrapped with a prefix
 * and suffix from the formatUnit.
 */

// unitFormats
export default {
  // --- Primitive units --- //
  string: {},
  number: {},
  date: {},
  link: {},
  boolean: {},

  // --- Format units --- //
  feet: {
    suffix: `'`,
  },
  amperes: {
    suffix: ` A`,
  },
  squareFeet: {
    suffix: ` SF`,
  },
  squareMeters: {
    suffix: ` m²`,
  },
  squareMiles: {
    suffix: ` mi²`,
  },
  perSquareFoot: {
    suffix: `/SF`,
  },
  pricePerSquareFoot: {
    prefix: `$`,
    suffix: `/SF`,
  },
  pricePerAcre: {
    prefix: `$`,
    suffix: `/Ac`,
  },
  pricePerFar: {
    prefix: `$`,
    suffix: `/FAR`,
  },
  taxBill: {
    prefix: `$`,
    suffix: `/SF`,
  },
  currency: {
    prefix: `$`,
  },
  currencyMillions: {
    prefix: `$`,
    suffix: ` MM`,
  },
  percentage: {
    suffix: `%`,
  },
  buildingCount: {
    suffix: ` Buildings`,
  },
  acreCount: {
    suffix: ` Acres`,
  },
  acreage: {
    suffix: ' Ac',
  },
  miles: {
    suffix: ' mi',
  },
  hours: {
    suffix: ' hr(s)',
  },
  months: {
    suffix: ` mos`,
  },
  megaWatts: {
    suffix: ` MW`,
  },
  megaWattsWhole: {
    suffix: ` MW`,
    maximumFractionDigits: 0,
  },
  megaVoltAmperes: {
    suffix: ` MVA`,
  },
  pricePerKilowattHour: {
    prefix: `$`,
    suffix: `/kWh`,
  },
  kiloVolts: {
    suffix: ` kV`,
  },
  inches: {
    suffix: ` in.`,
  },
  millionGallonsPerDay: {
    suffix: ` MGD`,
  },
  btuPerKWh: {
    suffix: ` Btu/KWh`,
  },
  year: {},
  years: {
    suffix: ` yrs`,
  },

  // --- Aggregated units --- //
  address: {},
  schedule: {},
  utilities: {},
};
